__turbopack_context__.v({
  "contour-draw": "overview-menu-preview-module__FyNPUW__contour-draw",
  "mark": "overview-menu-preview-module__FyNPUW__mark",
  "second": "overview-menu-preview-module__FyNPUW__second",
});
